var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('nav-bar'),_c('keep-alive',[_c('router-view')],1),_c('footer-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFooter),expression:"isFooter"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }